/* PATOYS header: sticky header, mobile menu, mega menu. No dependencies. */
class StickyHeader extends HTMLElement {
  connectedCallback() {
    this.header = document.querySelector('.section-header');
    if (!this.header) return;
    this.headerIsAlwaysSticky =
      this.getAttribute('data-sticky-type') === 'always' ||
      this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};

    this.setHeaderHeight();
    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    }

    this.compactHandler = () => {
      const y = window.pageYOffset || document.documentElement.scrollTop;
      if (y > 120) this.header.classList.add('pt-compact');
      else if (y < 40) this.header.classList.remove('pt-compact');
    };
    window.addEventListener('scroll', this.compactHandler, { passive: true });
    this.compactHandler();

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    const chips = this.header.querySelector('.pt-chips');
    if (chips && !this.header.classList.contains('pt-compact')) this.header.style.setProperty('--pt-chips-h', `${chips.scrollHeight}px`);
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
    window.removeEventListener('scroll', this.compactHandler);
  }

  createObserver() {
    const observer = new IntersectionObserver((entries, obs) => {
      this.headerBounds = entries[0].intersectionRect;
      obs.disconnect();
    });
    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);
        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closePanels();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  closePanels() {
    this.querySelectorAll('.pt-nav__item.is-open').forEach((item) => {
      item.classList.remove('is-open');
      const caret = item.querySelector('.pt-nav__caret');
      if (caret) caret.setAttribute('aria-expanded', 'false');
    });
    const burger = this.querySelector('[data-pt-burger]');
    if (burger && burger.getAttribute('aria-expanded') === 'true') burger.click();
  }
}

if (!customElements.get('sticky-header')) customElements.define('sticky-header', StickyHeader);

(function () {
  const root = document.querySelector('.pt-header');
  if (!root) return;

  /* Shorter search placeholder on phones. */
  const searchInput = root.querySelector('.pt-search__input');
  if (searchInput) {
    const mq = window.matchMedia('(max-width: 749px)');
    const longText = searchInput.getAttribute('placeholder');
    const shortText = searchInput.getAttribute('data-short-placeholder');
    const applyPlaceholder = () => searchInput.setAttribute('placeholder', mq.matches && shortText ? shortText : longText);
    applyPlaceholder();
    mq.addEventListener('change', applyPlaceholder);
  }

  /* Mobile menu: one button toggles the panel below the header. */
  const burger = root.querySelector('[data-pt-burger]');
  const panel = document.getElementById('PtMobileNav');
  if (burger && panel) {
    const setOpen = (open) => {
      burger.setAttribute('aria-expanded', String(open));
      panel.hidden = !open;
      root.classList.toggle('is-menu-open', open);
    };
    burger.addEventListener('click', () => setOpen(burger.getAttribute('aria-expanded') !== 'true'));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && burger.getAttribute('aria-expanded') === 'true') {
        setOpen(false);
        burger.focus();
      }
    });
  }

  /* Desktop mega menu: hover is handled in CSS; the caret button covers touch and keyboard. */
  const items = root.querySelectorAll('.pt-nav__item.has-mega');
  const closeAll = (except) => {
    items.forEach((item) => {
      if (item === except) return;
      item.classList.remove('is-open');
      item.querySelector('.pt-nav__caret').setAttribute('aria-expanded', 'false');
    });
  };
  items.forEach((item) => {
    const caret = item.querySelector('.pt-nav__caret');
    caret.addEventListener('click', () => {
      const open = !item.classList.contains('is-open');
      closeAll(item);
      item.classList.toggle('is-open', open);
      caret.setAttribute('aria-expanded', String(open));
    });
  });
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.pt-nav__item')) closeAll();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAll();
  });
})();